import { es_lang } from './es';
import { en_lang } from './en';

let translations = new Map<string, any>();
translations.set("es", es_lang);
translations.set("en", en_lang);

export { translations };
